import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const Button = styled.button`
  ${/* Button Theme */ ""}
  background: ${(props) => {
    switch (props.mode) {
      case "Light":
        if (props.types === "Primary") {
          return props.theme.colors.ombre;
        } else if (props.types === "Secondary") {
          return `linear-gradient(${
            props.theme.colors.mode_light_light +
            "," +
            props.theme.colors.mode_light_light
          }) padding-box, ${
            props.theme.colors.ombre
          } border-box; border:1px solid transparent !important;`;
        } else {
          return "none";
        }

      default:
        if (props.types === "Primary") {
          return props.theme.colors.ombre;
        } else if (props.type === "Secondary") {
          return `linear-gradient(${
            props.theme.colors.mode_dark_dark +
            "," +
            props.theme.colors.mode_dark_dark
          }) padding-box, ${
            props.theme.colors.ombre
          } border-box; border:1px solid transparent !important;`;
        } else {
          return "none";
        }
    }
  }};

  ${/* Button Width or Auto Width */ ""}
  ${(props) =>
    !props.autoWidth
      ? typeof props.width === "number"
        ? `width: ${props.width}px;`
        : `width: ${props.width};`
      : null}

  border-radius: 64px;
  display: flex;
  flex-direction: ${(props) => (props.types !== "Tertiary" ? "row" : "column")};
  align-items: center;
  border: none;
  padding: 8.5px 50px;
  position: static;
  justify-content: center;

  ${/* Button Font Theme */ ""}
  ${(props) => props.theme.text.POPPINS_BOLD_14_PX}

  ${/* Button Text Color Theme */ ""}
  color: ${(props) => {
    switch (props.mode) {
      case "Light":
        if (props.types === "Primary") {
          return props.theme.colors.text_color_dark_mode;
        } else {
          return props.theme.colors.mode_dark_dark;
        }

      default:
        if (props.types === "Primary") {
          return props.theme.colors.text_color_dark_mode;
        } else {
          return props.theme.colors.mode_light_light;
        }
    }
  }};

  margin: auto;
  text-align: center;

  ${/* Button Tertiary Type */ ""}
  ${(props) =>
    props.types === "Tertiary"
      ? `&:after{
    border-bottom: 1px solid ${props.theme.colors.brand1};
    gap: 10px;
    width: 100%;
    content: '';
  }`
      : ""}
`;

const Buttons = (props) => {
  return <Button {...props}></Button>;
};

// Using propTypes for easy Zeplin Reference on code inspector and better props handling
Buttons.propTypes = {
  mode: PropTypes.oneOf(["Dark", "Light"]).isRequired,
  autoWidth: PropTypes.bool.isRequired,
  width: function (props, propName, componentName) {
    if (props["autoWidth"] && props[propName] === undefined) {
      throw new Error(
        "You have set 'autoWidth' for Component <" +
          componentName +
          '/> that has children text value of "' +
          props.children.toString() +
          "\". Please set 'width' value in number or string format"
      );
    }
    switch (typeof props[propName]) {
      case "string":
        return;
      case "number":
        return;
      default:
        throw new Error(
          "Component for <" +
            componentName +
            '/> that has children text value of "' +
            props.children.toString() +
            "\" is accepting wrong value format. Please enter either in 'number' or 'string' format for " +
            propName +
            " props."
        );
    }
  },
  type: PropTypes.oneOf(["Primary", "Secondary", "Tertiary"]).isRequired,
  icon: PropTypes.bool,
  text: PropTypes.bool,
  badge: PropTypes.bool,
  iconPosition: PropTypes.oneOf(["Left", "Right"]),
};

export default Buttons;
